import { render, staticRenderFns } from "./TicketUpdateView.vue?vue&type=template&id=4c60d636&scoped=true&"
import script from "./TicketUpdateView.vue?vue&type=script&lang=js&"
export * from "./TicketUpdateView.vue?vue&type=script&lang=js&"
import style0 from "./TicketUpdateView.vue?vue&type=style&index=0&id=4c60d636&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60d636",
  null
  
)

export default component.exports